import React from 'react';
import stilePulsanti from '../../../interfaccia/stilePulsanti';

function BarraContatti({
    elemento,
    creaNuovoElemento,
    apriElemento,
    mobile,
    utente,
    filterText,
    setFilterText,
    filterTextBrand,
    setFilterTextBrand
}) {
  
    //TODO AGGIUNGERE RICERCA CON FILTRI COME INDICATO IN https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering

    const handleChange = async function (evt) {
        const value = evt.target.value;
        try {
            setFilterTextBrand("");
            setFilterText(value);
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
            throw err;
        }
    }

    const handleChangeBrand = async function (evt) {
        const value = evt.target.value;
        try {
            setFilterText("")
            setFilterTextBrand(value);
        } catch (err) {
            console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
            throw err;
        }
    }


  return (
    <div className={'formRicercaOrizzontale pb2 flex justify-between items-center'}>
        {utente.permessiAPI["update:database"] && <div className='dim pointer gruppoInputRicercaOrizzontale mr2' onClick={creaNuovoElemento}>
                    <button className=" tastoInputOrizzontale br3">{stilePulsanti.tastoNuovoAspetto}</button>
                    <span className='ml2 nonSelezionabile'>NUOVO</span>
                </div>}
        <div className='flex'>
        <div className='gruppoInputRicercaOrizzontale'>
                <label className='mr1 b nonSelezionabile' for="filterText">Nome</label>
                <input
                    value={filterText}
                    name="filterText"
                    onChange={handleChange}
                    id="filterText"
                    className="input-reset inputOrizzontale"
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
            </div> 
            <div className='ml3 gruppoInputRicercaOrizzontale'>
                <label className='mr1 b nonSelezionabile' for="filterText">Brand</label>
                <input
                    value={filterTextBrand}
                    name="filterTextBrand"
                    onChange={handleChangeBrand}
                    id="filterTextBrand"
                    className="input-reset inputOrizzontale"
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
            </div> 
            </div>
    </div>
  )
}

export default BarraContatti;